import ProjectsShowcase from '../../../components/feature/ProjectsShowcase';
import { useTranslation } from 'react-i18next';

export default function CaseStudy() {
  const { t } = useTranslation();

  return (
    <ProjectsShowcase
      badge={t('home.projects.badge')}
      title={t('home.projects.title')}
      description={t('home.projects.description')}
      limit={4}
      showAllButton
    />
  );
}
